import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { CharacterMetadata } from 'draft-js';
import { OrderedSet } from 'immutable';
import { REGEX_LEADING_LF, REGEX_LF, SPACE } from './constants';

var extractTextFromNode = function extractTextFromNode(node) {
  var _node$textContent;

  var text = (_node$textContent = node.textContent) !== null && _node$textContent !== void 0 ? _node$textContent : '';
  var trimmedText = text.trim(); // If the trimmed content is empty,
  // normalize to a single space.

  if (trimmedText === '') {
    text = ' ';
  } // Trim leading line feed, which is invisible in HTML


  text = text.replace(REGEX_LEADING_LF, ''); // Can't use empty string because MSWord

  text = text.replace(REGEX_LF, SPACE);
  return text;
};

var updateTextState = function updateTextState(newText, currentTextState) {
  var currentEntity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var currentStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : OrderedSet();
  var newCurrentText = currentTextState.text + newText;
  var characterMetadata = CharacterMetadata.create(_objectSpread({
    style: currentStyle
  }, currentEntity !== null ? {
    entity: currentEntity
  } : {}));
  var newCharacterList = currentTextState.characterList.concat(Array(newText.length).fill(characterMetadata));
  return {
    text: newCurrentText,
    characterList: newCharacterList
  };
};
/**
 * Add the content of an HTML text node to the internal state
 */


export var convertTextNodeToTextState = function convertTextNodeToTextState(node, textState, currentEntity, currentStyle) {
  var text = extractTextFromNode(node);
  return updateTextState(text, textState, currentEntity, currentStyle);
};
export var mergeTextStates = function mergeTextStates(processedNodes) {
  return processedNodes.reduce(function (_ref, _ref2) {
    var text = _ref.text,
        characterList = _ref.characterList;
    var textState = _ref2.textState;
    return {
      text: text + textState.text,
      characterList: characterList.concat(textState.characterList)
    };
  }, {
    text: '',
    characterList: []
  });
};